const STORAGE_USER_PREFIX = /^users\/([^/]+)\//;

export const extractStorageUid = (key?: string | null): string | null => {
  if (!key) return null;

  const match = key.match(STORAGE_USER_PREFIX);
  return match?.[1] ?? null;
};

export const replaceStorageUid = (
  key: string,
  fromUid: string,
  toUid: string
): string => key.replace(`users/${fromUid}/`, `users/${toUid}/`);
